import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { fetchUpdatePassword } from 'alelo-logic/actions'
import { reset } from 'redux-form'
import ChangePasswordForm from '../../modules/ChangePasswordForm'
import { showModal } from '../../modules/ModalRoot/actions'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'
import passwordFactory from './factory'

import { Content, Heading, Paragraph, Wrapper } from './styles'

import { helmetTitle, title, subtitle, modalTitle } from './data.json'

import image from '../../../static/alterarSenha.png'
import imageError from '../../../static/contestacao.png'

function ChangePassword({ handleSave }) {
  return (
    <Content>
      <Helmet title={helmetTitle} />
      <Heading>{title}</Heading>
      <Paragraph>{subtitle}</Paragraph>
      <Wrapper>
        <ChangePasswordForm
          hasCurrentPasswordField
          onSubmit={values => handleSave(passwordFactory.toAPI(values))}
        />
      </Wrapper>
    </Content>
  )
}

export const mapDispatchToProps = dispatch => ({
  handleSave: password =>
    dispatch(fetchUpdatePassword(password))
      .then(() => {
        dispatch(showModal(CONFIRM_UPDATE, { modalTitle, image }))
        dispatch(reset('changeUserPasswordData'))
      })
      .catch(() =>
        dispatch(
          showModal(CONFIRM_UPDATE, {
            modalTitle: 'Ocorreu algum problema!',
            modalDescription: 'Tente novamente mais tarde.',
            image: imageError
          })
        )
      )
})

export default connect(null, mapDispatchToProps)(ChangePassword)



// WEBPACK FOOTER //
// ./src/app/pages/ChangePassword/index.js